module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-pl.7d9493b9922b5789e05b.svg";